import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import DynamicComponent from "../components/Invite/DynamicComponent";
import DefaultComponent from "../components/Invite/DefaultComponent";
import { useEffect } from "react";
import { db } from '../repository/firebase_init';
import { collection, doc, setDoc } from "firebase/firestore";

const Option = () => {
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  useEffect(() => {
    const saveCodeToFirestore = async (type, code) => {
      try {
        const docRef = doc(collection(db, "public"), type || "unknown-type");
        await setDoc(docRef, { code }, { merge: true });
        console.log("Code saved successfully");
        if (type === "nukkad-foods") {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.nukkadfoods.nukkad_foods_new";
        } else if (type === "nukkad") {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.nukkadfoods.nukkad_partner";
        } else if (type === "nukkad-delivery-partner") {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.nukkadfoods.delivery_partner_new";
        }
      } catch (error) {
        console.error("Error saving code to Firestore:", error);
      }
    };
    if (code) saveCodeToFirestore(type, code);
  }, [type, code]);

  return (
    <div>
      {type ? (
        <DynamicComponent type={type} code={code} />
      ) : (
        <DefaultComponent />
      )}
    </div>
  );
};

export default Option;
